import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import fields from '../../lib/fields';
import FormFieldsCompact from '../../components/form/fieldsCompact';
import { appConfirm } from '../../lib/dialogs';
import { beginDialogAction } from '../../lib/dialogAction';

@observer
class EventEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('broadcastEvent'),
        };
    }

    loadAll = async () => {
        const { idx, id, isNew } = this.props;
        const { broadcastEventStore } = this.props.stores;
        if (!isNew) {
            broadcastEventStore.adminSetFromIdx(idx);
            if (id) {
                const idInt = parseInt(id, 10);
                const response = await broadcastEventStore.adminLoad({ id: idInt }, { skipUpdate: true });
                const adminList = response?.data;
                const obj = adminList?.[0];
                if (obj) {
                    broadcastEventStore.updateKeyValue('broadcastEvent', obj);
                }
            }
        }
    }

    createEvent = async () => {
        const { callback = () => {}, stores, drawerLevel = 1 } = this.props;
        const { broadcastEventStore, appState } = stores;
        const { newBroadcastEvent } = broadcastEventStore;
        const response = await util.fetchApi('/api/broadcastevents/', { method: 'POST' }, newBroadcastEvent);
        if (response.status === 201) {
            appState.toggleDrawer(false, drawerLevel);
            callback();
        }
    }

    closeDrawer = () => {
        const { callback = () => {}, stores, drawerLevel = 1 } = this.props;
        const { appState } = stores;
        appState.toggleDrawer(false, drawerLevel);
        callback();
    }

    deleteEvent = async () => {
        const dialogAction = beginDialogAction(this, 'deleteEvent', () => [
            this.props?.stores?.broadcastEventStore?.broadcastEvent?.id,
        ]);
        if (!dialogAction) return false;
        try {
            const { callback = () => {}, stores, drawerLevel = 1 } = this.props;
            const { broadcastEventStore, appState } = stores;
            const { broadcastEvent } = broadcastEventStore;

            if (!broadcastEvent?.id) return;

            const confirmed = ((await appConfirm('Er du sikker på at du vil slette denne hendelsen?')) && dialogAction.isCurrent());
            if (!confirmed) return;

            const response = await util.fetchApi(`/api/broadcastevents/${broadcastEvent.id}`, { method: 'PATCH' }, { offline: 1 });
            if (response.status === 200) {
                appState.toggleDrawer(false, drawerLevel);
                callback();
            }
        } finally {
            dialogAction.finish();
        }
    }

    handleCreateStream = () => {
        const { isNew, drawerLevel = 1, stores } = this.props;
        const { appState, broadcastEventStore, broadcastChannelStore } = stores;
        const event = isNew ? broadcastEventStore.newBroadcastEvent : broadcastEventStore.broadcastEvent;

        // Get streamUrl from the channel
        const channel = broadcastChannelStore.broadcastChannels.find(c => c.id === event.channel);
        const streamUrl = channel?.streamUrl || '';

        // Open new stream drawer with pre-populated data as props
        const initialData = {
            name: event.title || '',
            streamUrl,
            start: event.scheduledStart || '',
            end: event.scheduledEnd || '',
            color: event.backgroundColor || '',
        };
        if (event.race) {
            initialData.race = event.race;
        }
        appState.openDrawer('newStream', {
            height: 'calc(100vh - 100px)',
            initialData,
            callback: () => {
                // Optionally refresh after creating stream
            },
        }, drawerLevel + 1);
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, broadcastEventStore } = this.props.stores;
        const { user } = userStore;
        const { newBroadcastEvent, broadcastEvent } = broadcastEventStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <h5 class='ms-3 mb-3'>
                        <i class='fa-solid fa-calendar-plus me-2' />
                        {isNew ? 'Ny hendelse' : 'Rediger hendelse'}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact
                            stores={this.props.stores}
                            sections={sections}
                            holdingStore={broadcastEventStore}
                            objectName={isNew ? 'newBroadcastEvent' : 'broadcastEvent'}
                            isNew={isNew}
                            drawerLevel={drawerLevel}
                        />
                    </div>
                    <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style='bottom: 0; left: 0;'>
                        {isNew ? (
                            <button type='button' class='btn btn-primary rounded-pill' onClick={this.createEvent}>
                                <i class='fa-solid fa-plus me-2' />
                                Opprett hendelse
                            </button>
                        ) : (
                            <div class='d-flex flex-row justify-content-between'>
                                <div class='d-flex flex-row'>
                                    <button type='button' class='btn btn-outline-primary rounded-pill me-2' onClick={this.handleCreateStream}>
                                        <i class='fa-solid fa-video me-2' />
                                        Opprett stream
                                    </button>
                                    <button type='button' class='btn btn-secondary rounded-pill' onClick={this.closeDrawer}>
                                        <i class='fa-solid fa-check me-2' />
                                        Lukk
                                    </button>
                                </div>
                                <button type='button' class='btn btn-outline-danger rounded-pill' onClick={this.deleteEvent}>
                                    <i class='fa-solid fa-trash me-2' />
                                    Slett
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default EventEdit;
